<template>
  <div>
    <SearchBarComponent></SearchBarComponent>
    <b-container class="pt-5">
      <router-view name="modal"></router-view>
      <b-row>
        <b-col
          cols="6"
          md="3"
          class="mb-3"
          v-for="product in products"
          v-bind:key="product.url"
          :class="{ 'hidden': product.hidden && !$authenticated.value}"
        >
          <router-link v-if="product.hasApps" :to="{path: product.url }">
            <b-card
              :title="product.name"
              :img-src="product.icon"
              img-alt="Product icon"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2 nuiteq-card"
            >
              <div v-if="$authenticated.value">
                <router-link class="admin-button" :to="{path: '/' + product.url +'/edit'}">
                  <b-button class="nuiteq-button" variant="warning">Edit</b-button>
                </router-link>
                <router-link class="admin-button" :to="{path: '/' + product.url +'/delete'}">
                  <b-button class="nuiteq-button" variant="danger">Delete</b-button>
                </router-link>
              </div>
            </b-card>
          </router-link>
          <router-link v-else :to="{path: product.url + '/0/' }">
            <b-card
              :title="product.name"
              :img-src="product.icon"
              img-alt="Product icon"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2 nuiteq-card"
            >
              <div v-if="$authenticated.value">
                <router-link class="admin-button" :to="{path: '/' + product.url +'/edit'}">
                  <b-button class="nuiteq-button" variant="warning">Edit</b-button>
                </router-link>
                <router-link class="admin-button" :to="{path: '/' + product.url +'/delete'}">
                  <b-button class="nuiteq-button" variant="danger">Delete</b-button>
                </router-link>
              </div>
            </b-card>
          </router-link>
        </b-col>
        <b-col v-if="$authenticated.value" cols="6" md="3">
          <router-link :to="{path: '/new'}">
            <b-card
              title="Add Product"
              :img-src="addIcon"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2 nuiteq-card add-card"
            ></b-card>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import SearchBarComponent from './SearchBarComponent.vue';
import addIcon from '@/assets/images/add.svg';

export default {
  name: 'Products',
  components: { SearchBarComponent },
  data() {
    return {
      products: [],
      searchResults: [],
      searchQuery: '',
      showResults: false,
      addIcon
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.get(process.env.VUE_APP_BASE_URL + '/').then(response => {
      next(vm => {
        vm.setData(response.data);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.products = null;
    axios.get(process.env.VUE_APP_BASE_URL + '/').then(response => {
      this.setData(response.data);
      next();
    });
  },
  methods: {
    hideResults() {
      setTimeout(() => {
        this.showResults = false;
      }, 200);
    },
    setData(products) {
      this.products = products.sort((a,b) => (a.index > b.index) ? 1 : ((b.index > a.index ? -1 : 0)));
    },
    search() {
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
            '/' +
            'search?query=' +
            this.searchQuery
        )
        .then(response => {
          response.data;
          this.searchResults = response.data;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nuiteq-button {
  width: 100%;
  margin-bottom: 5px;
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

h2 {
  color: white;
  font-size: 56px;
  margin-bottom: 20px;
}

.hidden {
  display: none;
}

.admin-button {
  position: relative;
  z-index: 0;
}

.list-group-item img {
  max-height: 100%;
  width: 22px;
  margin-right: 12px;
}

.card-img-top {
  width: 74px;
  margin: auto;
}
.add-card > img:nth-child(1) {
  width: 158px;
}
h4.card-title {
  text-align: center;
  margin-bottom: 0px;
  font-size: 1.3rem;
}
.card {
  height: 100%;
  padding-top: 24px;
  transition: all 0.3s ease;
  border: none;
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 1.25rem;
}

.card-body {
  padding-bottom: 2px;
  padding-left: 0px;
  padding-right: 0px;
}

.card:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
  border: 1px solid #ef9743;
}

@media (max-width: 767px) {
  .card {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
    border: 1px solid #ef9743;
  }
  .card-img-top {
    width: 82px;
    margin: auto;
  }
}
</style>
